import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
  standalone: false,
})
export class FileSizePipe implements PipeTransform {
  transform(value: any): string {
    const sizes = [' Bytes', ' KB', ' MB', ' GB', ' TB'];
    let i = 0;
    let n = Number.parseInt(value, 10) || 0;
    while (n >= 1024 && ++i) {
      n = n / 1024;
    }
    return n.toFixed(n >= 10 || i < 1 ? 0 : 1) + sizes[i];
  }
}
